import { split, toLower } from "lodash";
import { ExportCategories, Frequency, ReportType } from "PFApp/booking/types/export_booking";
import { Report } from "PFApp/booking/types/manage_reports";
import api from "PFCore/api";
import { Collection, Filter, Value } from "PFTypes";

import {
  CreateTemplatePayload,
  ExportFieldsResponse,
  ExportFiltersOptionsResponse,
  ExportFiltersResponse,
  GenerateReportPayload
} from "./export_booking.types";
import { getMockedExportData } from "./getMockedExportData";

type FetchExportFiltersPayload = {
  reportType?: ReportType;
};

export const fetchExportFilters = ({
  reportType
}: FetchExportFiltersPayload): Promise<ExportFiltersResponse> => {
  const [type, groupBy] = split(toLower(reportType), "with");
  return api({
    url: "booking_module/reports/filters",
    params: {
      reportType: type,
      groupBy
    }
  });
};

export const fetchOptions = (
  filter: Filter,
  { term, value }: { term?: string; value?: Value } = {}
): Promise<ExportFiltersOptionsResponse> =>
  api({
    url: "booking_module/reports/filters/options",
    params: {
      filter: filter.name,
      ...(term ? { term } : {}),
      ...(value ? { value } : {})
    }
  });

type FetchExportFieldsPayload = {
  frequency: Frequency;
  reportType?: ReportType;
};

export const fetchExportFields = ({
  reportType,
  frequency
}: FetchExportFieldsPayload): Promise<ExportFieldsResponse> => {
  const [type, groupBy] = split(toLower(reportType), "with");

  return api({
    url: "booking_module/reports/fields",
    params: {
      reportType: type,
      aggregateBy: frequency,
      groupBy
    }
  });
};

type ExportDataResponse = Collection<ExportCategories[]>;

//TODO: use API endpoint once ready
export const fetchExportData = (): Promise<ExportDataResponse> => {
  const response = getMockedExportData();

  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(response);
    }, 0);
  });
};

export const createTemplate = (data: CreateTemplatePayload) =>
  api({
    url: "booking_module/reports/templates",
    method: "POST",
    data
  });

export const generateReport = (data: GenerateReportPayload): Promise<Report> =>
  api({
    url: "booking_module/reports/downloads",
    method: "POST",
    data
  });
